export const GET_SETTINGS = 'settings/get'

export const POST_SETTINGS = 'settings/post'
